module.exports = __webpack_public_path__ + "static/media/img04.3d930bfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/04/01/assets/img04.jpg
// module id = 516
// module chunks = 0